const queueMap = new Map<string, string>();

// queue_key	descript
// q_care_club	Care Club Queue
// q_customer_services	Customer Services
// q_customer_support	Customer Support Queue
// q_engineer_support	Logistics Support Queue
// q_existing_sales	Existing Sales
// q_feedback	Customer Services Support
// q_field_support	Field Support
// q_invoice_payments	Resolutions Queue
// q_new_sales	New Sales Queue
// q_noise	Noise Queue
// q_phone_test	Phone Test
// q_quotes	Quotes
// q_recruitment	Recruitment
// q_sales_overflow	Sales Overflow Queue
// q_Scheduled_Task	Scheduled Task
// q_test	Test Queue
// Quotes	Quotes
// Test	Test Queue

queueMap.set("q_care_club", "Care Club Queue");
queueMap.set("q_customer_services", "Customer Services");
queueMap.set("q_customer_support", "Customer Support Queue");
queueMap.set("q_engineer_support", "Logistics Support Queue");
queueMap.set("q_existing_sales", "Existing Sales");
queueMap.set("q_feedback", "Customer Services Support");
queueMap.set("q_field_support", "Field Support");
queueMap.set("q_invoice_payments", "Resolutions Queue");
queueMap.set("q_new_sales", "New Sales Queue");
queueMap.set("q_noise", "Noise Queue");
queueMap.set("q_phone_test", "Phone Test");
queueMap.set("q_quotes", "Quotes");
queueMap.set("q_recruitment", "Recruitment");
queueMap.set("q_sales_overflow", "Sales Overflow Queue");
queueMap.set("q_Scheduled_Task", "Scheduled Task");
queueMap.set("q_test", "Test Queue");

export default queueMap;
